export default __webpack_public_path__ + "static/media/img-0256-afghanistan-half-face.bf5fa7f0.png";